<main class="d-flex justify-content-center align-items-center align-content-center">
    <div class="box noshadow auto transp text-center home-simulator">
      
      <i class="fas fa-sliders-h"></i>
      <h2>Simule Seu Seguro de Vida</h2>
  
      <div class="row row-cols-1 row-cols-md-2 mt-5 text-left">
        <div class="col">
          
            <div class="">
                <h5>Cuide da sua Segurança e de sua Família!</h5>
                <ul class="list-unstyled pl-3">
                    <li>Seguro de Vida</li>
                    <li>Seguro de Invalidez</li>
                    <li>Seguro de Vida + Invalidez</li>
                </ul>
            </div>
            
            <div class="mt-5">
                <h5>A importância de ter o seguro Viva Mais Previdência:</h5>
                <p class="pl-3">
                    Contrate cobertura adicional conforme suas
                    necessidades e de sua família.
                </p>
            </div>
            
            <div class="mt-5">
                <h5>Personalize de acordo com suas necessidades!</h5>
                <p class="pl-3">
                    Faça sua adesão 100% digital.
                </p>
            </div>
    
        </div>
        <div class="col mt-5 text-center">
            <button type="button" class="btn btn-light d-inline-block" style="width: 300px;">TIRE SUAS DÚVIDAS</button>
    
            <br />
    
            <button type="button" class="btn btn-light d-inline-block mt-2" style="width: 300px;">MATERIAL EXPLICATIVO</button>

            <br />

            <a class="btn btn-secondary d-inline-block mt-5" style="width: 300px;" routerLink="/simulador-seguro/simular">Fazer Simulação</a>
        </div>
    </div>    
    
  
    </div>
</main>
